(function () {
  'use strict';

  /**
   * Cookie handling functions
   * https://www.w3schools.com/js/js_cookies.asp
   *
   * @param {String} cname
   */
  function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  function eraseCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  function createCookie(cookieName) {
    let expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);

    document.cookie = `${cookieName}=true; expires=${expirationDate}; path=/;`;
  }

  /**
   * Hiding header and footer when 'hide-header-footer' is in the url
   */

  const urlParams = new URL(document.location).searchParams;
  const shouldHideContent = urlParams.get('hide-header-footer');

  if (shouldHideContent === '1') {
    document.cookie = 'hide_header_footer=1';
  }

  let hideContentCookie = getCookie('hide_header_footer');
  let bodyTag = document.getElementsByTagName('body')[0];

  if (hideContentCookie === '1') {
    bodyTag.classList.add('hide-header-footer');
  } else {
    bodyTag.classList.remove('hide-header-footer');
  }
})();
